import { render } from "./romaneio-coletor-list.vue?vue&type=template&id=091f0740&scoped=true"
import script from "./romaneio-coletor-list.vue?vue&type=script&lang=js"
export * from "./romaneio-coletor-list.vue?vue&type=script&lang=js"

import "./romaneio-coletor-list.vue?vue&type=style&index=0&id=091f0740&scoped=true&lang=css"

import exportComponent from "C:\\Users\\iuril\\Documents\\econopro\\mainapp\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-091f0740"]])

export default __exports__